<template>


        <div class="relatorios">

            <el-form label-position="top">

                <el-tabs type="border-card" v-model="tabAtivo">
                    <el-tab-pane label="FILTROS" name="filtros">

                        <div>
                            <el-row :gutter="10" class="u-mt-10">
                                <el-col :xs="24" :sm="18" :md="18">
                                    <el-form-item label="Instituição" key="instituicao" v-if="$store.state.user.tipo == 10 || ($store.state.user.tipo > 3 && $store.state.user.tipo <= 8)">
                                        <el-select ref="instituicao_id" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição" clearable>
                                            <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <div class="style-form" v-if="$store.state.user.tipo <= 3 || $store.state.user.tipo == 9">
                                        <label class="el-form-item__label">Instituição</label>
                                        <div class="style-input readonly">{{ $store.state.config.instituicao.nome }}</div>
                                    </div>
                                </el-col>
                                <el-col :xs="24" :sm="6" :md="6">
                                    <el-form-item label="Período Letivo" key="periodo">
                                        <el-select ref="periodo_letivo_id" v-model="filtro.periodo_letivo_id">
                                            <el-option v-for="(item, i) in $store.state.periodos" :key="i" :label="item.nome" :value="item.id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row :gutter="10">
                                <el-col :xs="24" :sm="6" :md="6">
                                    <el-form-item label="Etapa" key="etapa">
                                        <el-select ref="etapa" v-model="filtro.etapa" filterable multiple clearable>
                                            <el-option v-for="(item, i) in $CONSTANTS.ETAPA" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="6" :md="6">
                                    <el-form-item label="Bairro" prop="bairro" key="bairro">
                                        <el-select ref="bairro" v-model="filtro.bairro" placeholder="pesquisar..." filterable remote :remote-method="getBairroByFilter" :loading="loadingBairro" clearable>
                                            <el-option v-for="item in selectBairros" :key="item.id" :label="item.nome" :value="item.nome"> </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="4" :md="4">
                                    <el-form-item label="Sexo" prop="sexo" key="sexo">
                                        <el-select ref="sexo" v-model="filtro.sexo" clearable>
                                            <el-option :key="0" label="MASCULINO" :value="0"></el-option>
                                            <el-option :key="1" label="FEMININO" :value="1"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="4" :md="4">
                                    <el-form-item label="Nascidos entre (Dt. inicial)" prop="data_nascimento_inicial" :rules="[$dataBlur]" key="data_nascimento_inicial">
                                        <el-input v-model="filtro.data_nascimento_inicial" maxlength="191" v-mask="'##/##/####'" v-on:blur="formatData('data_nascimento_inicial', 10)"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="4" :md="4">
                                    <el-form-item label="Dt. final" prop="data_nascimento_final" :rules="[$dataBlur]" key="data_nascimento_final">
                                        <el-input v-model="filtro.data_nascimento_final" maxlength="191" v-mask="'##/##/####'" v-on:blur="formatData('data_nascimento_final', 10)"></el-input>
                                    </el-form-item>
                                </el-col>

                            </el-row>

                            <el-row :gutter="10">
                                <el-col :xs="24" :sm="6" :md="6">
                                    <el-form-item label="Raça/Cor" prop="cor" key="cor">
                                        <el-select ref="cor" v-model="filtro.cor" multiple clearable>
                                            <el-option
                                                v-for="raca in $store.state.racas"
                                                :key="raca.id"
                                                :label="raca.nome"
                                                :value="raca.cod_censo">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="4" :md="4">
                                    <el-form-item label="Pai Declarado" prop="pai_declarado" key="pai_declarado">
                                        <el-select ref="pai_declarado" v-model="filtro.pai_declarado" clearable>
                                            <el-option :key="true" label="SIM" :value="true"></el-option>
                                            <el-option :key="false" label="NÃO" :value="false"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="10" :md="10">
                                    <el-form-item label="Curso" prop="curso_id" key="curso_id">
                                        <el-select ref="curso_id" @change="getTurmas()" v-model="filtro.curso_id" multiple clearable>
                                            <template v-for="(item, i) in selectCursos">
                                                <el-option v-if="item.curso_aluno" :key="i" :label="item.nome" :value="item.id"></el-option>
                                            </template>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="4" :md="4">
                                    <el-form-item label="Turma" prop="turma_id" key="turma_id">
                                        <el-select ref="turma_id" v-model="filtro.turma_id" multiple clearable>
                                            <el-option v-for="(item, i) in selectTurma" :key="i" :label="item.nome + ' - (' + item.curso.nome + ')'" :value="item.id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>



                            <el-row :gutter="10">

                                <el-col :xs="24" :sm="6" :md="6">
                                    <el-form-item label="Data da Matrícula (Dt. inicial)" prop="data_matricula_inicial" :rules="[$dataBlur]" key="data_matricula_inicial">
                                        <el-input v-model="filtro.data_matricula_inicial" maxlength="191" v-mask="'##/##/####'" v-on:blur="formatData('data_matricula_inicial', 10)"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="6" :md="6">
                                    <el-form-item label="Dt. final" prop="data_matricula_final" :rules="[$dataBlur]" key="data_matricula_final">
                                        <el-input v-model="filtro.data_matricula_final" maxlength="191" v-mask="'##/##/####'" v-on:blur="formatData('data_matricula_final', 10)"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="6" :md="6">
                                    <el-form-item label="Tipo de Ensino" prop="tipo_ensino" key="tipo_ensino">
                                        <el-select @change="tipoEnsino()" ref="tipo_ensino" v-model="filtro.tipo_ensino" multiple clearable>
                                            <el-option v-for="(item, i) in $CONSTANTS.TIPO_ENSINO" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="6" :md="6">
                                    <el-form-item label="Turno" prop="turno" key="turno">
                                        <el-select ref="turno" v-model="filtro.turno" multiple clearable>
                                            <el-option v-for="(item, i) in $CONSTANTS.TURNO" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                            </el-row>

                            <el-row :gutter="10">

                                <el-col :xs="24" :sm="8" :md="8">
                                    <el-form-item label="Apenas Turmas Multi" prop="multi_cursos" key="multi_cursos">
                                        <el-select ref="multi_cursos" v-model="filtro.multi_cursos" clearable>
                                            <el-option :key="true" label="SIM" :value="true"></el-option>
                                            <el-option :key="false" label="NÃO" :value="false"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                                <el-col :xs="24" :sm="8" :md="8">
                                    <el-form-item label="Detalhamento Turma Multi" prop="detalhamento_multi" key="detalhamento_multi">
                                        <el-select ref="detalhamento_multi" v-model="filtro.detalhamento_multi" clearable>
                                            <el-option :key="true" label="SIM" :value="true"></el-option>
                                            <el-option :key="false" label="NÃO" :value="false"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                                <el-col :xs="24" :sm="8" :md="8">
                                    <el-form-item label="Turmas Acelera" prop="curso_acelera" key="curso_acelera">
                                        <el-select ref="curso_acelera" v-model="filtro.curso_acelera" clearable multiple>
                                            <el-option :key="1473" label="ACELERA I" :value="1473"></el-option>
                                            <el-option :key="1474" label="ACELERA II" :value="1474"></el-option>
                                            <el-option :key="1476" label="ACELERA III" :value="1476"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                            </el-row>



                            <el-row :gutter="10">
                                <el-col :xs="24" :sm="8" :md="8">
                                    <el-form-item label="Recebe Bolsa Família" prop="recebe_bolsa_familia" key="recebe_bolsa_familia">
                                        <el-select ref="recebe_bolsa_familia" v-model="filtro.recebe_bolsa_familia" clearable>
                                            <el-option :key="true" label="SIM" :value="true"></el-option>
                                            <el-option :key="false" label="NÃO" :value="false"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="8" :md="8">
                                    <el-form-item label="Transportados" prop="utiliza_transporte" key="utiliza_transporte">
                                        <el-select ref="utiliza_transporte" v-model="filtro.utiliza_transporte" clearable>
                                            <el-option :key="true" label="SIM" :value="true"></el-option>
                                            <el-option :key="false" label="NÃO" :value="false"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="8" :md="8">
                                    <el-form-item label="Localização/Zona" prop="localizacao_zona" key="localizacao_zona">
                                        <el-select ref="localizacao_zona" v-model="filtro.localizacao_zona" clearable>
                                            <el-option v-for="(item, i) in $CONSTANTS.LOCALIZACAO_ZONA" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row :gutter="10">
                                <el-col :xs="24" :sm="12" :md="12">
                                    <el-form-item label="Situação da Matrícula" prop="situacao_matricula" key="situacao_matricula">
                                        <el-select ref="situacao_matricula" v-model="filtro.situacao_matricula" multiple>
                                            <template v-for="(item, i) in $CONSTANTS.SITUACAO_MATRICULA">
                                                <el-option :key="i" :label="item" :value="parseInt(i)"></el-option>
                                            </template>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="12" :md="12">
                                    <el-form-item label="Situação Acadêmica" prop="situacao_academica" key="situacao_academica">
                                        <el-select ref="situacao_academica" v-model="filtro.situacao_academica" multiple>
                                            <el-option v-for="(item, i) in $CONSTANTS.SITUACAO_ACADEMICA" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row :gutter="10">
                                <el-col :xs="24" :sm="12" :md="12">
                                    <el-form-item label="Alergias" prop="alergias" key="alergias">
                                        <el-select ref="alergias" v-model="filtro.alergias" multiple filterable>
                                            <el-option
                                                v-for="(item, i) in selectAlergias"
                                                :key="i"
                                                :label="item.nome"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="12" :md="12">
                                    <el-form-item label="Doenças" prop="doencas" key="doencas">
                                        <el-select ref="doencas" v-model="filtro.doencas" multiple filterable>
                                            <el-option
                                                v-for="(item, i) in selectDoencas"
                                                :key="i"
                                                :label="item.nome"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="10">    
                                <el-col :xs="24" :sm="12" :md="12">
                                    <el-form-item label="Deficiência" prop="deficiencias" key="deficiencias">
                                        <el-select ref="deficiencias" v-model="filtro.deficiencias" multiple>
                                            <el-option
                                                key="all"
                                                label="TODOS"
                                                value="all">
                                            </el-option>
                                            <el-option
                                                v-for="(item, i) in selectDeficiencias"
                                                :key="i"
                                                :label="item.nome"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="12" :md="12">
                                    <el-form-item label="Transtorno(s) que Impacta(m) o Desenvolvimento da Aprendizagem" prop="transtornoAprendizagem" key="transtornoAprendizagem">
                                        <el-select ref="transtornoAprendizagem" v-model="filtro.transtornoAprendizagem" multiple>                                           
                                            <el-option
                                                v-for="(item, i) in selectTranstornos"
                                                :key="i"
                                                :label="item.nome"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row :gutter="10">
                                <el-col :xs="24" :sm="18" :md="18">
                                    <el-form-item label="Nome do Aluno" prop="aluno" key="aluno">
                                        <el-input v-model="filtro.aluno" maxlength="191" v-on:blur="formatData('aluno')"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="6" :md="6">
                                    <el-form-item label="Apresentação dos Dados" prop="apresentacao_dados" key="apresentacao_dados">
                                        <el-select ref="apresentacao_dados" v-model="filtro.apresentacao_dados">
                                            <el-option key="1" label="ANALÍTICO (DETALHADO)" :value="1"></el-option>
                                            <el-option key="2" label="SINTÉTICO (RESUMIDO)" :value="2"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>

                    </el-tab-pane>
                    <el-tab-pane label="CAMPOS" name="campos">

                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="12" :md="12">
                                <label class="u-pl-5 u-mb-5" style="display: block; font-size: 15px;"><b>Campos de Aluno</b></label>
                                <div style="height: 415px; background-color: #f8f8f8; padding:10px;">
                                    <el-checkbox-group v-model="campos.aluno" class="checkbox-filtos">
                                        <el-checkbox label="nome">Nome</el-checkbox>
                                        <el-checkbox label="num_matricula">Número Matrícula</el-checkbox>
                                        <el-checkbox label="data_nascimento">Data Nascimento</el-checkbox>
                                        <el-checkbox label="idade_letiva">Idade Letiva</el-checkbox>
                                        <el-checkbox label="telefones">Telefones</el-checkbox>
                                        <el-checkbox label="mae">Filiação 1</el-checkbox>
                                        <el-checkbox label="pai">Filiação 2</el-checkbox>
                                        <el-checkbox label="responsavel">nome Responsável</el-checkbox>
                                        <el-checkbox label="parentesco">Parentesco</el-checkbox>
                                        <el-checkbox label="sexo">Sexo</el-checkbox>
                                        <el-checkbox label="cor">Cor</el-checkbox>
                                        <el-checkbox label="cartao_sus">Cartão SUS</el-checkbox>
                                        <el-checkbox label="municipioNascimento">Naturalidade</el-checkbox>
                                        <el-checkbox label="inep">INEP</el-checkbox>
                                        <el-checkbox label="cpf">CPF</el-checkbox>
                                        <el-checkbox label="rg">RG</el-checkbox>
                                        <el-checkbox label="rn">Certidão</el-checkbox>
                                        <el-checkbox label="nis">NIS</el-checkbox>
                                        <el-checkbox label="endereco">Endereço</el-checkbox>
                                        <el-checkbox label="observacao">Observação</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="12">
                                <label class="u-pl-5 u-mb-5" style="display: block; font-size: 15px;"><b>Campos de Matrícula</b></label>
                                <div style="height: 415px; background-color: #f8f8f8; padding:10px;">
                                    <el-checkbox-group v-model="campos.matricula" class="checkbox-filtos">
                                        <el-checkbox label="nome_curso_aluno">Curso</el-checkbox>
                                        <el-checkbox label="situacao_matricula">Situação da Matrícula</el-checkbox>
                                        <el-checkbox label="situacao_academica">Situação Acadêmica</el-checkbox>
                                        <el-checkbox label="data_matricula">Data da Matrícula</el-checkbox>
                                        <el-checkbox label="data_transferencia">Data de Transferência</el-checkbox>
                                        <el-checkbox label="nome_ultima_escola">Nome da Última Instituição</el-checkbox>
                                        <el-checkbox label="instituicao_id">Instituição</el-checkbox>
                                        <el-checkbox label="tipo_transporte_id">Transporte</el-checkbox>
                                        <el-checkbox label="autoriza_uso_imagem">Uso da Imagem</el-checkbox>
                                        <el-checkbox label="observacao">Observação</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                            </el-col>
                        </el-row>

                    </el-tab-pane>
                </el-tabs>


            </el-form>
            <div v-if="alertTipoEnsino" style="margin: 10px 0px;">
                <el-alert
                    title="Atenção! Você selecionou um tipo de ensino que não é regular. Isso significa que o aluno poderá ser listado mais de uma vez no relatório caso possua mais de uma matrícula (um no ensino regular e outra no não regular)."
                    type="warning">
                </el-alert>
            </div>
            <div class="u-mt-10">
                <el-row>
                    <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                        <el-button @click="renderRelatorioGeralAluno('excel')" :loading="loadingButtonExcel" type="primary">EXCEL</el-button>
                        <el-button class="u-ml-10" @click="renderRelatorioGeralAluno('pdf')" :loading="loadingButtonPdf" type="primary">PDF</el-button>
                        <el-button class="u-ml-10" @click="renderRelatorioGeralAluno('html')" :loading="loadingButtonHtml" type="primary">HTML</el-button>
                        <el-button class="u-ml-10" @click="renderRelatorioGeralAluno('word')" :loading="loadingButtonWord" type="primary">WORD</el-button>
                        <el-button class="u-ml-10" @click="renderRelatorioGeralAluno('txt')" :loading="loadingButtonTxt" type="primary">TXT</el-button>
                        <el-button class="u-ml-10" @click="renderRelatorioGeralAluno('json')" :loading="loadingButtonJson" type="primary">JSON</el-button>
                    </el-col>
                </el-row>
            </div>

        </div>


</template>
<script>
import CPanel from '../../../shared/c-panel/c-panel.vue';

export default {
    data: () => ({
        alertTipoEnsino: false,
        tabAtivo: 'filtros',
        loadingButtonExcel: false,
        loadingButtonPdf: false,
        loadingButtonHtml: false,
        loadingButtonWord: false,
        loadingButtonTxt: false,
        loadingButtonJson: false,
        statusList: true,
        loadingBairro: false,
        ref: [],
        campos:{
            aluno: [
                'num_matricula',
                'nome',
                'data_nascimento',
                'mae',
                'telefones',
                'cpf'
            ],
            matricula: []
        },
        filtro: {
            aluno: '',
            instituicao_id: '',
            periodo_letivo_id: '',
            etapa: [],
            bairro: '',
            sexo: '',
            data_nascimento_inicial: '',
            data_nascimento_final: '',
            cor: [],
            pai_declarado: '',
            curso_id: [],
            turma_id: [],
            data_matricula_inicial: '',
            data_matricula_final: '',
            tipo_ensino: [1, 2],
            turno: [],
            multi_cursos: '',
            detalhamento_multi: '',
            curso_acelera: [],
            recebe_bolsa_familia: '',
            utiliza_transporte: '',
            autoriza_uso_imagem: '',
            localizacao_zona: '',
            situacao_matricula: [1],
            situacao_academica: [],
            alergias: [],
            doencas: [],
            deficiencias: [],
            apresentacao_dados: 1,
            transtornoAprendizagem: [],
        },
        paginate: {
            page: 1,
            qtdItens: null,
        },
        items: [ ],
        selectBairros: [],
        selectCursos: [],
        selectTurma: [],
        selectAlergias: [],
        selectDoencas: [],
        selectDeficiencias: [],
        selectTranstornos: [],

    }),
    mounted () {

        this.filtro.periodo_letivo_id = this.$store.state.config.periodo.id;

        if(this.$store.state.user.tipo <= 3 || this.$store.state.user.tipo == 9){

            this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
        }

        this.initFormRelatorioAluno();
    },
    methods: {
        tipoEnsino(){

            this.alertTipoEnsino = false;

            for(let i in this.filtro.tipo_ensino){

                if(this.filtro.tipo_ensino[i] == 3 || this.filtro.tipo_ensino[i] == 4){

                    this.alertTipoEnsino = true;
                }
            }

            if(this.filtro.tipo_ensino.length == 0){

                this.alertTipoEnsino = true;
            }

        },
        renderRelatorioGeralAluno(tipo){

            if(this.campos.aluno.length == 0 && this.campos.matricula == 0){

                window.eventBus.$emit('alert', {msg: 'É necessário selecionar, pelo menos, um campo a ser apresentado no relatório.', type: 'warning'});
                return false;
            }

            this.ref = [
                { nome: 'Instituição', valor: ((this.$store.state.user.tipo <= 3 || this.$store.state.user.tipo == 9) ? this.$store.state.config.instituicao.nome : this.$refs.instituicao_id.selected.label) },
                { nome: 'Período Letivo', valor: this.$refs.periodo_letivo_id.selected.label },
                { nome: 'Bairro', valor: this.$refs.bairro.selected.label },
                { nome: 'Sexo', valor: this.$refs.sexo.selected.label },
                { nome: 'Nascido em (Dt. Inicial)', valor: this.filtro.data_nascimento_inicial },
                { nome: 'Nascido em (Dt. Final)', valor: this.filtro.data_nascimento_final },
                { nome: 'Pai Declarado', valor: this.$refs.pai_declarado.selected.label },
                { nome: 'Data da Matrícula (Dt. inicial)', valor: this.filtro.data_matricula_inicial },
                { nome: 'Data da Matrícula (Dt. final)', valor: this.filtro.data_matricula_final },
                { nome: 'Recebe Bolsa Família', valor: this.$refs.recebe_bolsa_familia.selected.label },
                { nome: 'Transportados', valor: this.$refs.utiliza_transporte.selected.label },
                { nome: 'Localização/Zona', valor: this.$refs.localizacao_zona.selected.label },
                { nome: 'Alergias', valor: this.getSelected(this.$refs.alergias.selected) },
                { nome: 'Doenças', valor: this.getSelected(this.$refs.doencas.selected) },
                { nome: 'Deficiência', valor: this.getSelected(this.$refs.deficiencias.selected) },
                { nome: 'Aluno', valor: this.filtro.aluno },
                { nome: 'Apresentação dos dados', valor: this.$refs.apresentacao_dados.selected.label },
                { nome: 'Detalhamento Turma Multi', valor: this.$refs.detalhamento_multi.selected.label },
                { nome: 'Transtornos da aprendizagem', valor: this.getSelected(this.$refs.transtornoAprendizagem.selected) },

            ];           
            

            if(this.$refs.etapa.selected.length > 0){
                this.addMultipleSelectFieldToRefFilter('Etapa', this.$refs.etapa.selected);
            }

            if(this.$refs.turno.selected.length > 0){
                this.addMultipleSelectFieldToRefFilter('Turno', this.$refs.turno.selected);
            }

            if(this.$refs.cor.selected.length > 0){
                this.addMultipleSelectFieldToRefFilter('Raça/Cor', this.$refs.cor.selected);
            }

            if(this.$refs.curso_id.selected.length > 0){
                this.addMultipleSelectFieldToRefFilter('Curso', this.$refs.curso_id.selected);
            }

            if(this.$refs.curso_acelera.selected.length > 0){
                this.addMultipleSelectFieldToRefFilter('Curso Acelera', this.$refs.curso_acelera.selected);
            }

            if(this.$refs.turma_id.selected.length > 0){
                this.addMultipleSelectFieldToRefFilter('Turma', this.$refs.turma_id.selected);
            }

            if(this.$refs.tipo_ensino.selected.length > 0){
                this.addMultipleSelectFieldToRefFilter('Tipo de Ensino', this.$refs.tipo_ensino.selected);
            }

            if(this.$refs.situacao_academica.selected.length > 0){
                this.addMultipleSelectFieldToRefFilter('Situação Acadêmica', this.$refs.situacao_academica.selected);
            }

            if(this.$refs.situacao_matricula.selected.length > 0){
                this.addMultipleSelectFieldToRefFilter('Situação Matrícula', this.$refs.situacao_matricula.selected);
            }

            if(tipo == 'pdf'){

                this.loadingButtonPdf = true;
                this.renderPdfRelatorioGeralAluno();

            }else if(tipo == 'html'){

                this.loadingButtonHtml = true;
                this.renderHtmlRelatorioGeralAluno();

            }else if(tipo == 'excel'){

                this.loadingButtonExcel = true;
                this.renderExcelRelatorioGeralAluno();
            }else if(tipo == 'word'){

                this.loadingButtonWord = true;
                this.renderWordRelatorioGeralAluno();
            }else if(tipo == 'txt'){

                this.loadingButtonTxt = true;
                this.renderTxtRelatorioGeralAluno();
            }else if(tipo == 'json'){

                this.loadingButtonJson = true;
                this.renderJsonRelatorioGeralAluno();
            }
        },
        renderPdfRelatorioGeralAluno(){

            window.eventBus.$emit('print', {url: '/api/pdf/renderRelatorioGeralAluno/pdf', param: {ref: this.ref, filtros: this.filtro, campos: this.campos, periodo_letivo: this.$refs.periodo_letivo_id.selected.label }});
            this.loadingButtonPdf = false;
        },
        renderExcelRelatorioGeralAluno(){

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pdf/renderRelatorioGeralAluno/excel`, { param: {ref: this.ref, filtros: this.filtro, campos: this.campos, periodo_letivo: this.$refs.periodo_letivo_id.selected.label} }, this.$store.getters.getHeaderAuthExcel).then(response => {

                this.loadingButtonExcel = false;

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'relatorio.xlsx');
                document.body.appendChild(link);
                link.click();

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        renderWordRelatorioGeralAluno(){

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pdf/renderRelatorioGeralAluno/word`, { param: {ref: this.ref, filtros: this.filtro, campos: this.campos, periodo_letivo: this.$refs.periodo_letivo_id.selected.label} }, this.$store.getters.getHeaderAuthExcel).then(response => {

                this.loadingButtonWord = false;

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'relatorio.docx');
                document.body.appendChild(link);
                link.click();

            }).catch((error) => { this.loadingButtonWord = false; this.$store.commit('throwException', error); });
        },
        renderTxtRelatorioGeralAluno(){

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pdf/renderRelatorioGeralAluno/txt`, { param: {ref: this.ref, filtros: this.filtro, campos: this.campos, periodo_letivo: this.$refs.periodo_letivo_id.selected.label} }, this.$store.getters.getHeaderAuthExcel).then(response => {

                this.loadingButtonTxt = false;

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'relatorio.txt');
                document.body.appendChild(link);
                link.click();

            }).catch((error) => { this.loadingButtonTxt = false; this.$store.commit('throwException', error); });
        },
        renderJsonRelatorioGeralAluno(){

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pdf/renderRelatorioGeralAluno/json`, { param: {ref: this.ref, filtros: this.filtro, campos: this.campos, periodo_letivo: this.$refs.periodo_letivo_id.selected.label} }, this.$store.getters.getHeaderAuthExcel).then(response => {

                this.loadingButtonJson = false;

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'relatorio.json');
                document.body.appendChild(link);
                link.click();

            }).catch((error) => { this.loadingButtonJson = false; this.$store.commit('throwException', error); });
        },
        async renderHtmlRelatorioGeralAluno(){

            try{

                let response = await this.getCodAutorizacaoRelatorioHtml();

                window.open(`${process.env.VUE_APP_BASE_URL}/api/relatorio/open/${response.data.token}`);

                this.loadingButtonHtml = false;

            }catch(e){

                window.eventBus.$emit('alert', {msg: 'Erro ao gerar relatório.', type: 'warning'});
            }

        },
        getCodAutorizacaoRelatorioHtml(){

            return this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/relatorio/generateCodAutorizacaoPrintHtml/geral-alunos`, {ref: this.ref, filtros: this.filtro, campos: this.campos, periodo_letivo: this.$refs.periodo_letivo_id.selected.label}, this.$store.getters.getHeaderAuth);
        },
        initFormRelatorioAluno(){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/relatorio/initFormRelatorioAluno`, this.$store.getters.getHeaderAuth).then(response => {

                this.selectAlergias = response.data.alergias;
                this.selectDoencas = response.data.doencas;
                this.selectDeficiencias = response.data.deficiencias;
                this.selectCursos = response.data.cursos;
                this.selectTranstornos = response.data.transtornoAprendizagem;    

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getTurmas(){

            if(!this.filtro.instituicao_id || !this.filtro.periodo_letivo_id || this.filtro.curso_id.length === 0){
                this.filtro.turma_id = [];
                return false;
            }

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getAllTurmasByCursos/` + this.filtro.instituicao_id + '/' + this.filtro.periodo_letivo_id + '/' + this.filtro.curso_id, this.$store.getters.getHeaderAuth).then(response => {

                this.selectTurma = response.data;

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

        },
        getBairroByFilter(query){

            if (query.length < 4){

                this.selectBairros = [];
                return false;
            }

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/bairro/searchByNome`, {query: query}, this.$store.getters.getHeaderAuth).then(response => {

                this.selectBairros = JSON.parse(JSON.stringify(response.data));

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getPagePagination(page){
          this.paginate.page = page;
          this.loadingModelos();
        },
        formatData(field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA

            if(!this.filtro[field])
                return false;

            if(size && this.filtro[field].length < size)
                this.filtro[field] = '';

            this.filtro[field] = this.filtro[field].toUpperCase();

            this.filtro[field] = this.$removerAcentos(this.filtro[field]);
        },
        getSelected(v){

            let t = '';
            for(let i in v){

                t += ' ' + v[i].label;
            }
            return t;
        },
        addMultipleSelectFieldToRefFilter(name, valuesSelected){
            const temp = { nome: name, valor: [] }
            valuesSelected.forEach(element => {
                temp.valor.push(element.currentLabel);
            });
            this.ref.push(temp);
        }
    }
}
</script>